/* 사흘 배역 명단 — 손으로 관리한다. 대본 원본(scenario/사흘/대본원본/역할지)과 맞출 것.
   (예전 생성기 tools/build-cast.ts 는 v3 원고를 읽던 것이라 2026-09-23 삭제했다) */

export interface CastDef {
  id: string;
  name: string;
  age: number;
  job: string;
  role: 'detective' | 'suspect' | 'victim';
  /** 전원이 처음부터 본다 */
  public: string;
  /**
   * **신체 프로파일.** 성별·나이·키·체격·신발·머리.
   * 현장의 물리 단서(소매 접힌 횟수, 뒤축 눌린 폭, 문틀에 쓸린 높이)는
   * 이 값과 대조해야 사람을 가리킨다. 없으면 그 단서들은 답이 없는 문제다.
   */
  body: string;
  /** **남이 나를 볼 때 보이는 것.** 왜 그런지는 본인 대본에만 있다 */
  look: string;
}

export const CAST: CastDef[] = [
  {
    id: "jung",
    name: "정우빈",
    age: 39,
    job: "군 단위 경찰서 형사팀 경위",
    role: "detective",
    public: "백설리를 관할하는 군 단위 경찰서 형사팀 경위. **발령받은 지 아직 2주가 안 됐다.**\n「꿈꾸는 청년조합」, 「730일 정착 실험」, 문 닫은 분교를 고쳐 청년 여섯이 2년째\n산다는 것 — 관할 인수자료에서 본 그 정도가 아는 전부고,\n여섯 중 얼굴을 직접 본 사람은 하나도 없다.\n\n12월 19일은 야간근무였다. 오후부터 폭설이 심해져 산간도로 일부가 통제됐고 제설차도 늦었다.\n21시 40분을 조금 넘긴 시각에 백설리에서 신고가 들어왔다.\n지원차량과 과학수사 인력이 눈에 막혀 바로 들어오지 못하는 사이,\n관할 안쪽에 있던 4륜 경찰차량으로 그가 먼저 올라왔다.\n\n순경으로 시작해 형사과로 옮겼고, 30대 초반에 지방경찰청 과학수사팀에서 5년을 현장으로 보냈다.\n법의관은 아니다. 현장에서 사망시각을 확정하지 않는다.\n말을 짧게 하고 되묻는다. 상대가 말을 다 끝낼 때까지 기다린다.\n현장을 안 건드리고 사람을 흩지 않는다 — 교과서 첫 장이 그것이다.",
    body: "성별 남 · 나이 39 · 키 178 · 체격 다부짐\n머리 검정, 짧게 깎았다. 왼쪽 눈썹에 오래된 흉터",
    look: "어깨와 무릎에 눈이 녹은 자국이 있다. 4륜 경찰차량으로 눈길을 뚫고 혼자 올라왔다.\n왼손에 접힌 종이 약도가 있고, 도착해서 제일 먼저 한 일이 사람들을 침실에서 내보내고\n현관부터 출입을 막은 것이었다. 이 마을 길을 모른다.",
  },
  {
    id: "myeong",
    name: "명주원",
    age: 36,
    job: "목수",
    role: "suspect",
    public: "여섯 중 최연장자다. 폐교 별관 목공방을 쓰고, 2년 동안 조합의 시설관리와 복구공사를 맡았다.\n백설리에 오기 전에는 경기도 외곽에서 작은 주문가구 공방을 했고 34살에 문을 닫았다.\n완주하면 장기 작업장 운영권을 협의한다는 조건 때문에 여기 들어왔다.\n\n뒤틀린 폐교 창틀도, 새는 빈집 지붕도, 겨울마다 어는 배관도 전부 이 사람 손을 거쳤다.\n문이 안 닫히면 부르는 사람이 이 사람이다.\n공용 비상키 캐비닛도 그가 관리한다 — 위치는 조합원 전부가 알지만 제일 자주 여는 것은 시설 담당이다.\n\n말이 적다. 물으면 답하고 안 물으면 안 한다. 그래서 오해를 자주 산다.\n손이 빠르고 눈대중이 정확해서 남이 만든 것도 한 번 보면 어디가 틀렸는지 안다.\n돈 얘기를 할 때만 목소리가 작아진다.\n\n19일 밤, 잠긴 현관을 다섯이 보는 앞에서 공용 비상키로 연 사람이 그다.",
    body: "성별 남 · 나이 36 · 키 172 · 체격 어깨가 넓다\n머리 검정에 흰 것이 섞였다, 짧다. 왼손 검지 끝 마디가 없다",
    look: "왼손 검지 끝 마디가 없고, 손톱 밑과 소매 접힌 골에 나무 가루가 껴 있어서\n악수를 하면 상대 손바닥에도 그게 묻는다. 오른쪽 팔뚝에만 근육이 몰려 있다.\n허리에 검은 작업벨트를 차고 있다.\n\n> 검지는 스물여섯에 테이블 쏘에서 잃었다. 그 뒤로 왼손으로는 자재를 받쳐만\n> 두고 켜고 깎고 조이는 것은 전부 오른손으로 한다. 십 년을 그렇게 했으니\n> 팔뚝이 한쪽만 굵다. 각재 한 다발을 한 손으로 세워 드는 일을 매일 한다.\n> **여섯 중 힘으로는 이 사람이 제일 낫다.**",
  },
  {
    id: "yuri",
    name: "차유리",
    age: 31,
    job: "로스터",
    role: "suspect",
    public: "폐교 카페와 로스터리를 맡았다. 로스터이고 동시에 인플루언서다.\n2년 동안 자기 채널로 이 마을을 알린 사람이 그다.\n\n대학을 나와 서울의 작은 스페셜티 카페에서 바리스타로 시작했고 거기서 로스팅을 배웠다.\n자기가 볶은 원두 이야기를 올리다 팔로워가 몇백에서 몇천, 어느 순간 몇만 명이 됐다.\n사람들은 커피뿐 아니라 그가 가는 곳과 쓰는 컵과 찍는 풍경까지 궁금해했다.\n\n여섯 중 제일 목소리가 크고 제일 많이 웃는다. 회의가 굳으면 먼저 농담을 하는 쪽이다.\n말이 빠르고 남의 말을 잘 끊는데, 미안하다는 말도 그만큼 빨리 한다.\n질문을 받으면 답이 이미 정리돼서 나온다 — 밖의 사람들에게 설명하는 일을 오래 했다.\n\n백설리 전에 작은 로스터리 브랜드를 한 번 열었다가 겨우 정리한 적이 있다.\n그때 배운 것이 있다. **한 번 잃은 신뢰는 돈으로 바로 살 수 없다.**\n그 뒤로 자기 이름과 얼굴을 브랜드처럼 관리한다.\n\n19일 밤, 회의에 대표가 나오지 않자 집에 가보자고 먼저 강하게 말한 사람이 그다.",
    body: "성별 여 · 나이 31 · 키 165 · 체격 마른 편이고 어깨가 좁다\n머리 갈색으로 물들였다, 어깨 아래. 손톱을 물어뜯은 자국",
    look: "손톱을 물어뜯은 자국이 열 손가락에 전부 새로 생겼고, 오른손 엄지는 살까지 파여\n반창고를 붙였다. 그리고 12월 17일부터 사흘째 같은 검정 기모 후드다.\n옆에 소형 카메라와 로스터리 태블릿을 늘 놓아두고, 저녁 내내 개인폰을 손에서 놓지 않는다.",
  },
  {
    id: "bae",
    name: "배정호",
    age: 34,
    job: "회계",
    role: "suspect",
    public: "회계와 계약과 정산을 맡았다. 사업계획서, 분기 정산서, 실적보고서를 전부 그가 쓴다.\n행정 용어를 아는 유일한 사람이라 군청과 재단 상대도 그가 한다.\n회계사이고, 백설리에 오기 전에는 중견 회계법인에서 감사와 정부지원사업 정산을 했다.\n\n면접에서 한서진에게 처음 한 말이 「이 계획대로면 첫겨울 전에 돈 떨어집니다」였고,\n그다음이 「돈 떨어지기 전에 구조 바꾸면 됩니다」였다.\n그 뒤로 2년 동안 한서진이 큰 방향을 정하면 그것을 숫자로 바꾸는 것이 그의 일이었다.\n둘은 자주 싸웠지만 결정은 빨랐다.\n\n숫자를 다루는 사람 특유의 신중함이 있다. 결론을 먼저 말하고 근거를 뒤에 댄다.\n남이 화를 내면 목소리를 더 낮춘다. 그게 침착한 걸로도 계산적인 걸로도 보인다.\n그리고 무슨 일이 생기면 **먼저 서류부터 편다.**\n사람에게 묻는 것보다 종이에 묻는 게 빠른 사람이다.",
    body: "성별 남 · 나이 34 · 키 176 · 체격 마름\n머리 검정, 가르마. 은테 안경. 왼 손목에 시계 자국만 있고 시계가 없다",
    look: "안경을 자주 닦는다. 그리고 손목에 시계 자국만 있고 시계가 없다.",
  },
  {
    id: "yun",
    name: "윤가람",
    age: 28,
    job: "도예가",
    role: "suspect",
    public: "막내다. 도예실과 가마실을 맡았고, 2년 동안 조합의 그릇을 만들었다.\n대학에서 도예를 전공했고, 그전에는 공동공방을 옮겨 다니며 가마 사용시간을 예약해 쓰던 사람이다.\n모집공고에서 제일 먼저 눈에 들어온 것이 「폐교 일부를 공방으로 사용 가능 · 별도 가마실 설치 가능」이었다.\n면접에서 여기 와서 제일 만들고 싶은 게 뭐냐고 묻자 「작업실이요」라고 답했다.\n\n처음 왔을 때 도예 작업실은 바닥이 기울어 있었고 가마실은 아예 새로 만들어야 했다.\n두 번째 해에 백설리의 눈 색을 닮은 흰 유약으로 생활식기를 만들었고,\n사람들이 그것을 **백설 백유**라고 불렀다.\n차유리의 채널과 체험프로그램을 통해 팔렸고, 조합 판매실적에서 적지 않은 몫이었다.\n\n낯을 가리고 말수가 적다. 사람 눈을 잘 안 맞추고, 대답하기 전에 생각하는 시간이 다른 사람보다 길다.\n그런데 자기 작업 얘기가 나오면 갑자기 길어진다. 「그냥 그릇」이라고 하면 표정이 바뀐다.\n**싫은 것을 싫다고 말하지 않는다.** 대신 그 자리를 조용히 뜬다.\n\n19일 밤 20시 50분에 대표 개인 휴대폰으로 전화를 건 사람이 그다. 전원이 꺼져 있었다.",
    body: "성별 여 · 나이 28 · 키 170 · 체격 보통\n머리 검정, 하나로 묶었다. 손이 늘 트고 갈라져 있다",
    look: "손이 늘 트고 갈라져 있고, 손톱 밑에 흙이 들어가 있는데 그건 도예 하는 사람이면\n누구나 그렇고, 다만 손등 바깥쪽에 최근에 새로 긁힌 자국이 세 줄쯤 있고\n왼쪽 엄지 밑동에 물집이 터진 자리가 아직 붉다.\n작업복 차림 그대로 왔고 앞자락에 흰 가루가 묻어 있다.",
  },
  {
    id: "song",
    name: "송이경",
    age: 33,
    job: "사진가",
    role: "suspect",
    public: "사진과 기록, 브랜딩을 맡았다. 서류상 부대표다.\n상업촬영으로 시작했다가 서른 즈음부터 사라지는 공간과 사람을 찍었다 —\n철거 직전의 상가, 문 닫는 여관, 폐교, 사람이 빠져나간 동네.\n\n2024년에 「백설리 730일 정착 실험」 모집공고를 봤을 때 눈에 들어온 것은\n귀촌도 지원금도 아니고 **730일**이라는 숫자였다. 한 장소를 정확히 2년 동안 기록할 수 있다는 것.\n지원서에 이렇게 썼다. 「성공한 마을만 찍지 않겠습니다. 실패하는 과정까지 남기겠습니다.」\n\n처음에는 대표와 기록담당이었다. 첫겨울을 함께 버티며 늦은 밤까지 둘이 남아 일하다 가까워졌고,\n두 번째 해에는 여섯 중 한서진과 가장 가까운 사람이 됐다.\n\n먼저 말을 꺼내는 쪽이 아니다. 회의에서는 거의 듣기만 하다가 마지막에 한 마디 한다.\n그 한 마디로 결론이 나는 일이 2년 동안 여러 번 있었다.\n남의 사정을 잘 기억한다. 누가 무슨 약을 먹는지, 누가 뭘 못 먹는지 전부 안다.\n\n19일 밤, 대표가 회의에 나오지 않자 이상하다고 가장 먼저 말한 사람이고,\n21시 40분에 지구대로 신고 전화를 건 사람도 그다.",
    body: "성별 여 · 나이 33 · 키 163 · 체격 마르고 어깨가 좁다\n머리 검정, 어깨까지. 눈 밑이 검고 화장기가 없다",
    look: "눈 밑이 검고 사흘째 화장을 안 했다. 눈이 붉게 부어 있다. 그리고 손이 계속 차다.\n좌석 등받이에 카메라가 걸려 있고 검은 스트랩이 늘어져 있다.",
  },
  {
    id: "han",
    name: "한서진",
    age: 33,
    job: "꿈꾸는 청년조합 대표",
    role: "victim",
    public: "꿈꾸는 청년조합 대표. 33살. 2024년에 이 사업을 기획해 지원했고, 다섯을 면접으로 뽑았다.\n\n1998년에 문을 닫은 백설분교를 고쳐 만든 조합센터가 이 마을의 중심이다.\n민간 지역재생재단과 군청이 함께 걸어 둔 장기 실증사업의 이름은 **「백설리 730일 정착 실험」**.\n사람이 사라진 산촌을 여섯 명만으로 다시 생활하고 일할 수 있는 마을로 만들 수 있는가.\n사업기간은 정확히 730일이고, **두 번의 겨울을 실제로 버텨야 했다.**\n완주하면 에스크로에 묶인 마을 전환금 **6억 4천만 원**이 조합으로 나오고,\n폐교와 작업시설의 장기 운영권을 넘겨받고, 여섯은 각자 쓰던 집과 공방을 장기계약으로 돌린다.\n지급 예정시각은 **2026년 12월 19일 오후 6시**였다.\n\n대표는 서류를 쥔다. 군과 재단에 나가는 공문, 각자의 소득 증빙, 계약과 정산의 최종 결재가\n전부 대표 명의로 나간다. 대표가 결재를 하지 않으면 그 서류는 존재하지 않는다.\n\n중요한 마감이 걸리면 자기 집 작업방에 틀어박히는 버릇이 있었다. 하루나 이틀, 길면 사흘.\n전화를 받지 않고 업무용 메신저로 필요한 말만 보냈다. 문에는 붉은 자석표시를 붙였다 —\n「마감 중 — 긴급상황 외 출입 금지」. 밤새 일하다 의자를 끌고, 서랍을 거칠게 닫고,\n답답하면 서류철을 책상에 내려놓는 소리까지 2년을 같이 산 사람들은 알고 있었다.\n\n**12월 16일 밤 공동회의에서 말했다.**\n「19일 전환금은 받지 않겠습니다.」 「중단 요청을 넣을 겁니다.」\n**「지난 2년 동안 우리가 제출한 자료도 전부 정정하겠습니다.」**\n회의실이 뒤집혔고 다섯이 각자 자기 자료를 물었다. 대답은 모두에게 같았다.\n「내가 시킨 일도 적었습니다.」 「내가 한 일도 같이 제출합니다.」\n그리고 덧붙였다. 「19일 저녁까지 혼자 정리하겠습니다.」 「그전에는 찾아오지 마세요.」\n「20시 30분에 센터 회의실에서 마지막으로 이야기합시다.」\n\n17일에도 18일에도 19일에도 다섯은 업무 메신저로 한서진의 지시를 받았다.\n그 집에서 사람이 움직이는 소리를 들은 사람도 있다.\n그런데 12월 19일 20시 30분 회의에 한서진은 나오지 않았다. 전화도 받지 않았다.\n21시 18분에 명주원이 공용 비상키로 현관을 열었고,\n**21시 40분, 침실 붙박이장 안에서 한서진이 발견됐다.**\n17일 · 18일 · 19일에 그 얼굴을 직접 봤다고 말할 수 있는 사람은 아무도 없다.\n\n> **여기까지가 전원이 아는 것이다.**\n>\n> 예비 부검 결과가 사망시점을 어디로 잡는지, 사흘 동안의 메시지와 소리를 누가 만들었는지,\n> 12월 16일 밤 그 집에 마지막으로 들어간 사람이 누구인지, 왜 하필 사흘이어야 했는지 —\n> 넷 다 이 게임의 답이다. 공개 정보에 적으면 게임이 시작하기 전에 끝난다. 아래로 내린다.\n>\n> **진행자와 시나리오 검토용이고 대본에는 안 들어간다.**\n\n---",
    body: "성별 여 · 나이 33 · 키 168 · 체격 보통\n머리 검정, 짧다",
    look: "",
  },
];

export const CAST_BY_ID: Record<string, CastDef> = Object.fromEntries(
  CAST.map((c) => [c.id, c]),
);

/** 배역을 받을 수 있는 사람 — 피해자는 뺀다 */
export const PLAYABLE = CAST.filter((c) => c.role !== 'victim');
